import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getDashboardPath, validateAdminSubscription } from '../../services/auth/authApi';

function ProtectedRoute({ allowedRoles, loginPath = '/', children }) {
  const { isAuthenticated, account, loading, logout, authNotice } = useAuth();
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;

    async function guardAdminSubscription() {
      if (!isAuthenticated || account?.role !== 'admin' || !account.gym_id) return;
      // Uses in-memory TTL cache — almost free after login already validated
      const check = await validateAdminSubscription(account.gym_id);
      if (!cancelled && !check.valid) {
        await logout();
      }
    }

    guardAdminSubscription();
    return () => { cancelled = true; };
  }, [isAuthenticated, account, logout]);

  if (loading) {
    return (
      <div className="auth-loading">
        <div className="auth-loading-spinner" aria-hidden="true" />
        <p>Loading…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to={loginPath}
        replace
        state={{ from: location.pathname, notice: authNotice }}
      />
    );
  }

  if (allowedRoles?.length && !allowedRoles.includes(account.role)) {
    return (
      <Navigate
        to={getDashboardPath(account.role)}
        replace
        state={{
          notice: account.role === 'owner'
            ? 'Owner accounts use the owner portal at /owner.'
            : 'Sign in with the correct account for this panel.',
        }}
      />
    );
  }

  return children;
}

export default ProtectedRoute;
